import { Text, Grid, GridItem, cnMixSpace } from 'uikit';

import cn from 'classnames';
import type React from 'react';
import type { ReactNode } from 'react';

export type ReadFieldProps<T> = {
    label: string;
    value: T;
    render?: (value: T) => React.ReactNode;
    formatter?: (value: T) => string;
    classWrapper?: string;
    classFirstText?: string;
    classSecondText?: string;
    labelLeftSide?: string | ReactNode;
    labelRightSide?: string | ReactNode;
};

const leftSideStyle = { marginRight: 5 };
const rightSideStyle = { marginLeft: 5 };
const gridWithLeftStyle = { display: 'flex', alignItems: 'center' };

export const ReadField = <T = any,>(props: ReadFieldProps<T>) => {
    const {
        label,
        value,
        classWrapper,
        classFirstText,
        classSecondText,
        render,
        formatter,
        labelLeftSide,
        labelRightSide,
    } = props;

    return (
        <Grid
            cols={classWrapper ? undefined : 5}
            gap={classWrapper ? undefined : 'xl'}
            className={cn(classWrapper, cnMixSpace({ mB: 'm' }))}
        >
            <GridItem
                col={classFirstText ? undefined : 2}
                className={classFirstText}
                style={labelLeftSide || labelRightSide ? gridWithLeftStyle : undefined}
            >
                {labelLeftSide && <div style={leftSideStyle}>{labelLeftSide}</div>}
                <Text size="s" view="secondary">
                    {label}
                </Text>
                {labelRightSide && <div style={rightSideStyle}>{labelRightSide}</div>}
            </GridItem>
            <GridItem col={3} className={classSecondText}>
                {render ? render(value) : <Text size="s">{formatter ? formatter(value) : value}</Text>}
            </GridItem>
        </Grid>
    );
};

ReadField.displayName = 'ReadField';
